import { render, staticRenderFns } from "./DoctorCardSkeleton.vue?vue&type=template&id=5d46de78&scoped=true&"
import script from "./DoctorCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./DoctorCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./DoctorCardSkeleton.vue?vue&type=style&index=0&id=5d46de78&lang=scss&"
import style1 from "./DoctorCardSkeleton.vue?vue&type=style&index=1&id=5d46de78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d46de78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d46de78')) {
      api.createRecord('5d46de78', component.options)
    } else {
      api.reload('5d46de78', component.options)
    }
    module.hot.accept("./DoctorCardSkeleton.vue?vue&type=template&id=5d46de78&scoped=true&", function () {
      api.rerender('5d46de78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/mobile/skeletons/DoctorCardSkeleton.vue"
export default component.exports